"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createChangePropertyActionTypes = _interopRequireDefault(require("./actions/createChangePropertyActionTypes"));

var _createSimpleStagedObjectReducer = _interopRequireDefault(require("./reducers/createSimpleStagedObjectReducer"));

var _createSimpleStagedObjectSelectors = _interopRequireDefault(require("./selectors/createSimpleStagedObjectSelectors"));

var _createAddToOrderedMapAction = _interopRequireDefault(require("./actions/createAddToOrderedMapAction"));

var _createRemoveFromOrderedMapAction = _interopRequireDefault(require("./actions/createRemoveFromOrderedMapAction"));

var _createReorderOrderedMapAction = _interopRequireDefault(require("./actions/createReorderOrderedMapAction"));

var _createChangePropertyAction = _interopRequireDefault(require("./actions/createChangePropertyAction"));

var _createResetChangesForStagedObjectAction = _interopRequireDefault(require("./actions/createResetChangesForStagedObjectAction"));

var _default = function _default(_ref) {
  var stagedSelector = _ref.stagedSelector,
      properties = _ref.properties,
      objectType = _ref.objectType,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? "" : _ref$namespace;
  var actionTypes = (0, _createChangePropertyActionTypes.default)({
    namespace: namespace,
    objectType: objectType,
    properties: properties
  });
  var reducer = (0, _createSimpleStagedObjectReducer.default)({
    namespace: namespace,
    objectType: objectType,
    properties: properties,
    actionTypes: actionTypes
  });
  var selectors = (0, _createSimpleStagedObjectSelectors.default)({
    stagedSelector: stagedSelector,
    properties: properties
  });
  var anyChanges = selectors.anyChanges;

  var changeProperty = function changeProperty(property) {
    return (0, _createChangePropertyAction.default)({
      actionTypes: actionTypes,
      property: property
    });
  };

  var getChangePropertyActionType = function getChangePropertyActionType(property) {
    return actionTypes[property];
  };

  var getReducer = function getReducer() {
    return reducer;
  };

  var getStagedObject = function getStagedObject(state) {
    return stagedSelector(state);
  };

  var getStagedProperty = function getStagedProperty(property) {
    return selectors.getStagedProperty(property);
  };

  var getStagedOrderedMapPropertyAsArray = function getStagedOrderedMapPropertyAsArray(property) {
    return selectors.getStagedOrderedMapPropertyAsArray(property);
  };

  var addToStagedOrderedSet = function addToStagedOrderedSet(property) {
    return (0, _createAddToOrderedMapAction.default)({
      actionTypes: actionTypes,
      property: property
    });
  };

  var removeFromStagedOrderedSet = function removeFromStagedOrderedSet(property) {
    return (0, _createRemoveFromOrderedMapAction.default)({
      actionTypes: actionTypes,
      property: property
    });
  };

  var reorderStagedOrderedSet = function reorderStagedOrderedSet(property) {
    return (0, _createReorderOrderedMapAction.default)({
      actionTypes: actionTypes,
      property: property
    });
  };

  var resetChangesToStagedObject = (0, _createResetChangesForStagedObjectAction.default)({
    namespace: namespace,
    objectType: objectType
  });
  return {
    anyChanges: anyChanges,
    addToStagedOrderedSet: addToStagedOrderedSet,
    changeProperty: changeProperty,
    getChangePropertyActionType: getChangePropertyActionType,
    getReducer: getReducer,
    getStagedObject: getStagedObject,
    getStagedProperty: getStagedProperty,
    getStagedOrderedMapPropertyAsArray: getStagedOrderedMapPropertyAsArray,
    removeFromStagedOrderedSet: removeFromStagedOrderedSet,
    reorderStagedOrderedSet: reorderStagedOrderedSet,
    resetChangesToStagedObject: resetChangesToStagedObject
  };
};

exports.default = _default;
module.exports = exports.default;